// @flow

import withPage from 'hocs/page';

import User from './user-container';

export default withPage<any>(User);
